module.exports = __webpack_public_path__ + "img/tips3list3img19120307.4881555d.jpg";